import axios from 'axios';

const baseURL = `${process.env.REACT_APP_API_URL}`;

export const productCategoryAPI = {
  add: async (info) => axios.post(`${baseURL}/product-categories`, info).then((res) => res.data),
  all: async () => axios.get(`${baseURL}/product-categories`).then((res) => res.data),
  single: async (idToSearch) => axios.get(`${baseURL}/product-category/${idToSearch}`).then((res) => res.data),
  update: async (idToSearch) => {
    const { id, ...details } = idToSearch;
    return axios.put(`${baseURL}/product-category/${id}`, details).then((res) => res.data);
  },
  addSubCategories: async (idToSearch) => {
    const { id, ...details } = idToSearch;
    return axios.put(`${baseURL}/add-subcategory-to-product-category/${id}`, details).then((res) => res.data);
  },
  delete: async (idToSearch) => axios.delete(`${baseURL}/product-category/${idToSearch}`).then((res) => res.data),
  getSubCategories: async (idToSearch) =>
    axios.get(`${baseURL}/get-sub-categories-by-category/${idToSearch}`).then((res) => res.data)
};
